export default "__VITE_ASSET__GUC9blVU__"